import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toNumber } from "lodash";
import { Column } from "@/shared/ui/Blocks";
import { ModalFileName } from "@/shared/modals";
import { ScreenContainer } from "@/shared/ui/ScreenContainer";
import { Title } from "@/shared/ui/Title";
import { ProjectsTable } from "@/features/projects/components/ProjectsTable";
import { usePositions } from "@/features/projects/hooks/usePositions";
import { useOrganisation } from "@/features/organization/hooks/useOrganisation";
import { useModal } from "@/shared/utils/hooks/useModal";
import { useEvent, EVENT_TYPES } from "@/shared/contexts/event.context";
import { useAccount } from "@/features/workspace/hooks/useAccount";
import { AccessLevel } from "@/shared/constants";
import useViewerPermissions from "@/features/workspace/hooks/useViewerPermissions";
import { ResourceEnum } from "@/shared/constants/resources";
import { HeaderContent } from "@/shared/widgets";
import { IconButton } from "@/shared/ui";

export default function () {
  const { t } = useTranslation();
  const { emitEvent } = useEvent();

  useEffect(() => {
    emitEvent({
      type: EVENT_TYPES.PROJECTS_LIST_VIEW,
    });
  }, []);

  const { getAccountConfigValue } = useAccount();

  const { validateAccessToResource, permissionsLoading } =
    useViewerPermissions();

  const { organization } = useOrganisation();

  const [openNewProjectModal] = useModal(ModalFileName.NEW_PROJECT);

  const { positions, loading } = usePositions(
    toNumber(organization.id)
    // toNumber(viewer.id)
  );

  const pageTitle =
    getAccountConfigValue("feature_config.projects.title") ||
    t("feature.projects");

  const hasAccess = validateAccessToResource({
    resourceType: ResourceEnum.organization,
    accessLevel: AccessLevel.limited,
  });

  const hasEditAccess = validateAccessToResource({
    resourceType: ResourceEnum.organization,
    accessLevel: AccessLevel.edit,
  });

  return (
    <ScreenContainer
      loading={loading || permissionsLoading}
      loadingMessage={t("common.loading_projects")}
      className="overflow-y-auto"
      permissionLocked={!hasAccess}
    >
      <HeaderContent>
        {hasEditAccess && (
          <IconButton
            icon="Plus"
            label={t("projects.create_new_project")}
            onClick={() => openNewProjectModal()}
          />
        )}
      </HeaderContent>
      <Title description={t("projects.assessment_studio_description")}>
        {pageTitle}
      </Title>
      <Column className="mt-8 gap-4">
        <ProjectsTable
          data={positions}
          loading={loading}
          readOnly={!hasEditAccess}
        />
      </Column>
    </ScreenContainer>
  );
}
